/**
 * A storefront opened with `?r=` (the dashboard's "view" links add it) asks the
 * API to skip the edge copy of its payload, so a seller checking a change they
 * just saved always sees it.
 */
export const FRESH_HEADER = "X-Fresh";

export function freshHeaders(search: string): Record<string, string> {
  return new URLSearchParams(search).has("r") ? { [FRESH_HEADER]: "1" } : {};
}

/** A public URL with the marker, for links the seller opens to check their work. */
export function withFreshMarker(url: string, now = Date.now()): string {
  try {
    const u = new URL(url, "https://placeholder.invalid");
    u.searchParams.set("r", String(now));
    return url.startsWith("http") ? u.toString() : `${u.pathname}${u.search}${u.hash}`;
  } catch {
    return url;
  }
}
